import { Room } from "@/Common/Api/Appointment/Dto/Room";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { ICheckable } from "@/Common/Models/UI/Inputs/ICheckable";

class RoomUIModel implements ICheckable {
    public Id: string;
    public Name: string;
    public Checked: boolean;
    public Target: CheckboxTarget;
    public Model: any;
    public Visible: boolean;

    constructor() {
        this.Id = GuidHelper.Empty();
        this.Name = "";
        this.Checked = false;
        this.Target = CheckboxTarget.Unassigned;
        this.Model = null;
        this.Visible = true;
    }

    public static FromCompositeObject(resource: Room): RoomUIModel {
        var o = new RoomUIModel();
        o.Model = resource;
        o.Id = resource.Id;
        o.Name = resource.Name;
        o.Model = resource;
        return o;
    }
}

export { RoomUIModel };
